import { __assign, __rest } from "tslib";
import React from 'react';
import { cn } from '@bem-react/classname';
import './Spin.css';
export var cnSpin = cn('Spin2');
/**
 * Индикатор загрузки. Отображает выполнение какого-то процесса, например загрузки сайта или медиа-файла.
 * @param {ISpinProps}
 */
export var Spin = function (_a) {
    var className = _a.className, innerRef = _a.innerRef, progress = _a.progress, 
    // Извлекаем свойства, т.к. они не нужны на DOM узле
    // FIXME: https://github.com/bem/bem-react/issues/381
    // @ts-ignore
    _view = _a.view, 
    // @ts-ignore
    _position = _a.position, 
    // @ts-ignore
    _size = _a.size, props = __rest(_a, ["className", "innerRef", "progress", "view", "position", "size"]);
    return React.createElement("div", __assign({}, props, { ref: innerRef, className: cnSpin({ progress: progress }, [className]) }));
};
Spin.displayName = cnSpin();
